import { type CheckboxProps, Checkbox as TamaguiCheckbox } from "tamagui";
import { Check } from "@tamagui/lucide-icons";

/**
 * Checkbox component with built-in styling and a checkmark icon
 */
export const Checkbox = (props: CheckboxProps) => {
  return <TamaguiCheckbox unstyled width={20} height={20} borderRadius={4} borderWidth={1} borderColor={props.checked ? "$navy" : "$strokeSecondary"} justifyContent="center" alignItems="center" backgroundColor={props.checked ? "$navy" : "$background"} {...props} data-sentry-element="TamaguiCheckbox" data-sentry-component="Checkbox" data-sentry-source-file="Checkbox.tsx">
      <TamaguiCheckbox.Indicator unstyled data-sentry-element="TamaguiCheckbox.Indicator" data-sentry-source-file="Checkbox.tsx">
        <Check strokeWidth={2} size={15} color="$background" data-sentry-element="Check" data-sentry-source-file="Checkbox.tsx" />
      </TamaguiCheckbox.Indicator>
    </TamaguiCheckbox>;
};